import { Flex } from "@chakra-ui/react";
import React from "react";

const Footer = () => {
  return (
    <Flex justify={"center"} p="5">
      Designed and Developed by Sanjay Gupta &#169; 2022 All rights reserved.
    </Flex>
  );
};

export default Footer;
